// extracted by mini-css-extract-plugin
export default {"services-section":"ServicesSection_services-section__sRg-N","get-in-touch-link":"ServicesSection_get-in-touch-link__Ruh8J"};